import React, { useState } from "react";
import '../../css/spendDetail.css'
import { useTabletMediaQuery, useMobileMediaQuery, errorHandling } from '../../utils';
import Modal from 'react-bootstrap/Modal';
import CustomButton from "../CustomButton";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { GoDotFill } from "react-icons/go";
import IconDialog from "../../assets/svg/iconDialog.svg"
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import IconNotifySuccess from '../../assets/svg/mainIconNotifySuccess.svg';  
import { AiOutlineStop } from "react-icons/ai";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from 'react-redux';
import { setRefreshConsultaDeducoes } from '../../features/onboardingData/onboardingUserData';

const CustomModalSpendDetail = (props) => {
    const {
        text = '',
        date = '',
        cardNumberTitle = '',
        apoliceTitle = '',
        nib = '',
        amountSpent = '',
        isPending = '',
        seqCativo = '',
        enabledBtn = '',
        motivo = '',
        setRefresh
    } = props;

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const dispatch = useDispatch();
    const [isStartingLoadingDots, setIsStartingLoadingDots] = useState(false)
    const [errorCancelar, setErrorCancelar] = useState(false)
    const [showCancelar, setShowCancelar] = useState(false);
    const handleCloseCancelar = () => setShowCancelar(false);
    const handleShowCancelar = () => setShowCancelar(true);
    const iban = nib?.match(/.{1,4}/g)?.join(" ") ?? "";

    const fetchCSRFToken = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
            });
            const data = await response.json();
            const csrfToken = data.csrfToken;
    
            return csrfToken;
        } catch (error) {
            errorHandling('CSRF');
        }
    };

    const postCancelaDeducao = async () => {
        setIsStartingLoadingDots(true);
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/cancelaDeducao/fetchCancelaDeducao`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    "xsrf-token": csrfToken,
                },
                credentials: "include",
                mode: "cors",
                body: JSON.stringify({ seqCativo: seqCativo }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.erroMsg === 'Success') {
                setShowCancelar(false);
                setIsStartingLoadingDots(false);
                dispatch(setRefreshConsultaDeducoes(true));
                props.onHide();
                toast.success("O pedido de transferência foi cancelado. Deve receber o saldo na sua Carteira dentro de momentos.",  {
                    icon: <img src={IconNotifySuccess} alt="icon" className="toast_iconNotifySuccess" />
                });
            } else {
                setShowCancelar(false);
                setIsStartingLoadingDots(false);
                setErrorCancelar(true);
                props.onHide();
                toast.error("Lamentamos, mas neste momento, não conseguimos cancelar a dedução. Por favor, tente mais tarde.", {
                    icon: <AiOutlineStop/>
                });
            }
        } catch (error) {
            setIsStartingLoadingDots(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modalMainContainerSpendDetail"
            contentClassName="modalMainContainerScrollSpendDetail"
            fullscreen
        >
            <div className={ isTablet ? 'modalBtnCloseContainerSpendDetailInfo' : ( isMobile ? 'modalBtnCloseContainerSpendDetailInfoTablet' : 'modalBtnCloseContainerSpendDetailInfoMobile' ) }>
                <button className='btnViewFirstCloseTitleSpendDetail' onClick={props.onHide}><IoMdClose className="closeIconSpendDetail" /></button>
            </div>
            <div className={ isTablet ? 'contentViewSpendDetail' : ( isMobile ? 'contentViewSpendDetail' :  'contentViewSpendDetailMobile' )}>
                <div className="titleViewContainerSpendDetail">
                    {/* <div className={ isTablet ? 'iconCssView' : ( isMobile ? 'iconCssView' : 'iconCssViewMobile' )}>
                        <img src={IconDialog} alt="icon" className="iconCss" />
                    </div> */}
                    <div className='titleMainViewSpendDetail'>Resumo da transferência</div>
                </div>
                <div className={ isTablet ? 'secondContentSpendDetail' : ( isMobile ? 'secondContentSpendDetail' : 'secondContentSpendDetail' )}>
                    <div className="textViewContainerSpendDetail">
                        <div className="titleSmallSpendDetail">{amountSpent}€</div>
                    </div>

                    <div className='txtNoMovementViewContainerSpendDetail'>
                        <div className='textBoldSpendDetailTop'>Informação da transferência</div>
                        { !!isPending &&
                            <div className='textSpendDetailTop'>{isPending.subTitleDesc}</div>
                        }
                    </div>

                    <div className="infoViewContainerSpendDetail">
                        <div className="txtInfoTitleViewContainerSpendDetail">
                            <div className={isTablet ? "titleViewSpendDetail" : "titleViewSpendDetailMobile"} >Transferência</div>
                        </div>
                        <div className="txtNoMovementRowViewContainerSpendDetail">
                            <div className="txtNoMovementColunmViewContainerSpendDetail">
                                <div className="txtNoMovementSecondRowViewContainerSpendDetail">
                                    <div className="textSpendDetail" >Valor a deduzir</div>
                                    <div className='textBoldSpendDetail'> {amountSpent}€</div>
                                </div>
                                <div className="txtNoMovementSecondRowViewContainerSpendDetail">
                                    <div className="textSpendDetail">Seguro</div>
                                    <div className='textBoldSpendDetail'>Cartão Médis {cardNumberTitle}</div>
                                </div>
                                <div className="txtNoMovementSecondRowViewContainerSpendDetail">
                                    <div className="textSpendDetail">Estado da dedução</div>
                                    <div className='rowDataBoxViewContainerSpendDetail'>
                                        <div className='mainModalInfoStatusDataBoxViewSpendDetail' style={{ background: isPending?.color }}>
                                            <div className='iconModalInfoStatusDataBoxSpendDetail' style={{ color: isPending?.iconColor }} ><GoDotFill /></div>
                                            <div className='txtModalInfoStatusDataBoxSpendDetail'>{isPending?.title}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="txtNoMovementSecondRowViewContainerSpendDetail">
                                    <div className="textSpendDetail">IBAN</div>
                                    <div className='textBoldSpendDetail'>PT50 {iban}</div>
                                </div>
                                <div className="txtNoMovementSecondRowViewContainerSpendDetail">
                                    <div className="textSpendDetail">Data de pagamento</div>
                                    <div className='textBoldSpendDetail'> {date}</div>
                                </div>
                            </div>
                        </div>
                        { enabledBtn === 'S' &&
                            <div className="txtNoMovementSecondColunmViewContainerSpendDetail">
                                <div className="txtInfoSubTitleViewContainerSpendDetail">
                                    <div className='txtAlerSmModalSeeSpendDetail'>Esta transferência foi cancelada</div>
                                 </div>
                                 <div className="txtNoMovementSecondSubRowViewContainerSpendDetail">
                                    <div className="textSpendDetail" >Motivo do cancelamento</div>
                                    <div className='textBoldSpendDetail'> {motivo}</div>
                                </div>
                            </div>
                        }
                        { !!isPending.txtBottomInfo &&
                            <div className="bottomDescriptionSpendDetailView">
                                <div className="bottomDescriptionSpendDetail">{isPending.txtBottomInfo}</div>
                            </div>
                        }
                    </div>
                    
                    <Modal
                        show={showCancelar} 
                        onHide={handleCloseCancelar}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        className="modalCancelarMainContainerSpendDetail"
                        contentClassName="modalCancelarMainContentContainerSpendDetail"
                        fullscreen
                        
                    >
                        <div className={ isTablet ? 'modalBtnCloseContainerSpendDetailInfo' : ( isMobile ? 'modalBtnCloseContainerSpendDetailInfoTablet' : 'modalBtnCloseContainerSpendDetailInfoMobile' ) }>
                            <button className='btnViewFirstCloseTitleSpendDetail' onClick={handleCloseCancelar}><IoMdClose className="closeIconSpendDetail" /></button>
                        </div>
                        <div className={ isTablet ? 'contentViewSpendDetail' : ( isMobile ? 'contentViewSpendDetail' :  'contentViewSpendDetailMobile' )}>
                            <div className="titleViewContainerSpendDetail">
                                {/* <div className={ isTablet ? 'iconCssView' : ( isMobile ? 'iconCssView' : 'iconCssViewMobile' )}>
                                    <img src={IconDialog} alt="icon" className="iconCss" />
                                </div> */}
                                { errorCancelar ? 
                                    <div className='titleMainViewSpendDetail'>Não foi possível cancelar</div>
                                    
                                    :
                                    
                                    <div className='titleMainViewSpendDetail'>Cancelar transferência</div>
                                }
                            </div>
                            <div className={ isTablet ? 'secondCancelarContentSpendDetail' : ( isMobile ? 'secondCancelarContentSpendDetail' : 'secondCancelarContentSpendDetailMobile' ) }>
                                <div className='txtNoMovementViewContainerSpendDetail'>
                                    { errorCancelar ? 
                                        <div className='iconInfoModalSpendDetail'>
                                            Já não é possível cancelar esta transferência, por motivos diversos e variados que vamos dizer aqui nesta mensagem muito simpática para o utilizador saber o que fazer.
                                        </div>

                                        :
                                        
                                        <div className='iconInfoModalSpendDetail'>
                                            Tem a certeza que quer cancelar a transferência de saldo para a sua conta bancária? Ao cancelar, o saldo pendente será devolvido à sua Carteira.
                                        </div>
                                    }
                                </div>

                                { errorCancelar ? 
                                    <div className={ isTablet ? 'btnViewSpendDetail' : ( isMobile ? 'btnViewSpendDetail' : 'btnViewSpendDetailMobile' )}>
                                        <CustomButton
                                            text={'Compreendido'}
                                            textColor={'#00214D'}
                                            onPress={handleCloseCancelar}
                                            color={'#15D4B6'}
                                        />
                                    </div>
                                    
                                    :
                                    
                                    <div className={ isTablet ? 'btnViewSpendDetail' : ( isMobile ? 'btnViewSpendDetail' : 'btnViewSpendDetailMobile' )}>
                                        <div className="btnSubLineViewSpendDetail">
                                            <CustomButton
                                                text={'Manter transferência'}
                                                textColor={'#141414'}
                                                hasSubLine
                                                hasSubLineSmall
                                                hasSubLineSmallColor={'#00214D'}
                                                onPress={handleCloseCancelar}
                                                hasShadow={false}
                                            />
                                        </div>
                                        <CustomButton
                                            text={'Cancelar transferência'}
                                            textColor={'#00214D'}
                                            onPress={postCancelaDeducao}
                                            color={'#15D4B6'}
                                            hasArrow
                                            iconColor={'#00214D'}
                                            loading={isStartingLoadingDots}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </Modal >

                </div>
                <div className={ isTablet ? 'btnViewSpendDetail' : ( isMobile ? 'btnViewSpendDetail' : 'btnViewSpendDetailMobile' )}>
                    { enabledBtn === 'N' &&
                        <CustomButton
                            text={'Cancelar transferência de saldo'}
                            borderColor={'#00214D'}
                            textColor={'#00214D'}
                            onPress={handleShowCancelar}
                            hasArrow
                            iconColor={'#00214D'}
                            hasShadow={false}
                        />
                    }
                </div>
            </div>
        </Modal >
    );
};

export default CustomModalSpendDetail;